module.exports = __webpack_public_path__ + "img/Heart.ed7483bb.svg";